/* tslint:disable:variable-name */
import {MasterService} from './../../services/master.service';
import {UserRolesModalComponent} from './../../../shared/user-roles-modal/user-roles-modal.component';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {AutofillMonitor} from '@angular/cdk/text-field';
import {StockService} from '../../services/stocks.service';
import {PaginationInstance} from 'ngx-pagination';
import {InvoiceModalComponent} from '../../../shared/invoice-modal/invoice-modal.component';
import {PurchaseorderModalComponent} from '../../../shared/purchaseorder-modal/purchaseorder-modal.component';
import {DeleteModalService} from '../../services/delete-modal.service';
import {CommonAlertService} from "../../../services/common-alert.service";
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';


@Component({
  selector: 'app-user-roles',
  templateUrl: './user-roles.component.html',
  styleUrls: ['./user-roles.component.scss']
})
export class UserRolesComponent implements OnInit {
  public user_roles: any;
  public filter: any;
  total_count: number;
  // tslint:disable-next-line:variable-name
  current_page: number;
  // tslint:disable-next-line:variable-name
  last_page: number;
  // tslint:disable-next-line:variable-name
  per_page: number;
  stockPageId = 'stockPageId';
  pageEvent: PageEvent;
  paginationID = 'listing_pagination';
  public selectedIndex = 0;
  public searchBy: any = 0;
  public searchTxt: any;
  placeHolder: any = 'Search By User Name';
  @Input() id: string;
  @Input() maxSize: number;
  @Output() pageChange: EventEmitter<number>;
  itemToBePushed: any;
  public config: PaginationInstance = {
    id: 'custom',
    itemsPerPage: 10,
    currentPage: 1
  };
  //public childMessage = 'listing_pagination';
  bool = false;
  public viewPermission = false;
  public addPermission = false;
  public editPermission = false;
  public deletePermission = false;
  constructor(public dialog: MatDialog, public stockService: StockService, public masterService: MasterService, public deleteModalService: DeleteModalService, public commonAlertService: CommonAlertService ) {
  }
  ngOnInit() {
    // @ts-ignore
    // tslint:disable-next-line:triple-equals
    if (localStorage.getItem('roleId') == 0) {
      // @ts-ignore
      // tslint:disable-next-line:max-line-length
      this.viewPermission = this.addPermission = this.editPermission = this.deletePermission = true;
    } else {
      const roles = JSON.parse(localStorage.getItem('roles'));
      // tslint:disable-next-line:triple-equals max-line-length
      if (roles['more.users_roles.view'] == 1 || roles['more.users_roles.add'] == 1 || roles['more.users_roles.edit'] == 1 || roles['more.users_roles.delete'] == 1) {
        this.viewPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users_roles.add'] == 1) {
        this.addPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users_roles.edit'] == 1) {
        this.editPermission = true;
      }
      // tslint:disable-next-line:triple-equals
      if (roles['more.users_roles.delete'] == 1) {
        this.deletePermission = true;
      }
    }
    this.filter = {
      token: localStorage.getItem('token')
    };
    this.getData();
  }
  getData() {
    this.masterService.getIndex('/user_roles/index', this.filter).subscribe(res => {
      // @ts-ignore
      this.user_roles = res.data.items;
      // @ts-ignore
      this.users = res.data.items;
      // @ts-ignore
      this.total_count = res.data.total;
      // @ts-ignore
      this.last_page = res.data.last_page;
      // @ts-ignore
      this.per_page = res.data.per_page;
      this.itemToBePushed = (this.last_page * this.per_page) - this.total_count;
      this.total_count = this.total_count + (this.last_page * this.per_page - this.total_count);
      // @ts-ignore
      this.current_page = res.data.current_page;
      this.bool = true;
      const newData = {
        id: '',
        name: ''
      };
      // @ts-ignore
      if (this.user_roles.length < 10) {
        for ( let i = this.user_roles.length; i < 9 ; i++) {
        //for ( let i = 0; i < 9 ; i++) {
          this.user_roles.push(newData);
        }
      }
      // @ts-ignore
      if(res.data.total == 0){ 
       this.commonAlertService.showEmptyMsg({message: 'No Details Found.'})
      }
    });
  }
  openDialog() {
    const dialogRef = this.dialog.open(UserRolesModalComponent, {
      minHeight: '300px',
      minWidth: '90vw',
      disableClose: true,
      autoFocus: true
    }).afterClosed().subscribe(() => this.getData());
  }
   getSearchValue() {
    if (this.searchBy) {
      switch (this.searchBy) {
        case '0':
          this.placeHolder = 'Search By Name';
          break;
        default: this.placeHolder = 'Search By Name';
      }
    }
  }
  editDialog(index) {
    const editId = this.user_roles[index].id;
    const encID = this.user_roles[index].enc_id;
    // tslint:disable-next-line:triple-equals
    if ( editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(UserRolesModalComponent, {
        minWidth: '90vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID
        }
      }).afterClosed().subscribe(() => this.getData());
    }
  }

  // Delete the purchase order
  deleteDialog(i): void {
    this.deleteModalService.openModal({
      id: this.user_roles[i].id,
      encId: this.user_roles[i].enc_id,
      token: localStorage.getItem('token'),
      deleteUrl: '/user_roles/destroy'
    });

    this.deleteModalService.closed.subscribe(() => {
      this.commonAlertService.showEdit({message: 'Record Deleted Successfully'});
      this.getData();
    });
  }
  doSearch(): void {

  if (this.searchBy != null) {
      switch (this.searchBy) {
        case '0':
          Object.assign(this.filter, {search: { type: 'str', field: 'user_roles.name', text: this.searchTxt}});
          break;
        default:
          Object.assign(this.filter, {search: { type: 'int', field: 'user_roles.name', text: this.searchTxt}});
      }
    }

    /*this.filter = {'search':{'type': this.searchBy.type, 'field': this.searchBy.field, 'text': this.searchTxt}};*/
  this.getData();
  }

  selectRow(index: number) {
    this.selectedIndex = index;
  }

  openEditDialog(index): void {
    // console.log('items', index);
    const editId = this.user_roles[index].id;
    const encID = this.user_roles[index].enc_id;
    // this.masterService.getRecordById();

    // tslint:disable-next-line:triple-equals
    if (editId != undefined && encID != undefined) {
      const dialogRef = this.dialog.open(UserRolesModalComponent, {
        minWidth: '90vw',
        disableClose: true,
        data: {
          id: editId,
          enc_Id: encID
        }
      }).afterClosed().subscribe(() => this.getData());
    }

  }
  doRefresh(): void {
     this.searchTxt = null;
     this.filter = {
       token: localStorage.getItem('token')
     };
     this.getData();
  }
  doPaginate(e): void {
    Object.assign(this.filter, {page: e});
    this.getData();
  }
}
